/**
 *Angular module*/
import {AfterViewInit, Component, Input} from '@angular/core';
import {AbstractControl, FormControl} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';

/**
 *Shared*/

@Component({
    selector: 'app-error-message',
    template: `
        <pre>{{control?.errors|json}}</pre>
        <div *ngIf="submitted && control.errors">
            <div *ngIf="control?.errors['required']" translate>{{lang}}.REQUIRE.{{getControlName(control)}}</div>
            <div *ngIf="control?.errors?.pattern" translate>{{ pattern | async }}</div>
            <div *ngIf="control?.errors?.minlength?.requiredLength" translate
                 [translateParams]="{_MIN_: control?.errors?.minlength?.requiredLength}">
                {{ pattern | async }}
            </div>
        </div>
    `
})
export class ErrorMessageComponent implements AfterViewInit {
    @Input() submitted = false;
    @Input() control: FormControl;
    @Input() lang: string;
    pattern;

    constructor(private translate: TranslateService) {
    }

    ngAfterViewInit(): void {
        this.pattern = this.getPatterns();
    }

    getControlName(c: AbstractControl): string | null {
        const formGroup = c.parent.controls;
        return Object.keys(formGroup).find((name: any) => c === formGroup[name]).replace('_', '-').toUpperCase() || null;
    }

    getPatterns() {
        return new Promise((resolve: any) => {
            this.translate.get(this.lang + '.PATTERN.NUMBER.' + this.getControlName(this.control)).toPromise().then((data: string) => resolve(data));
            this.translate.get(this.lang + '.PATTERN.STRING.' + this.getControlName(this.control)).toPromise().then((data: string) => resolve(data));
        });
    }
}
